/**
 * Foto de perfil (30): recorte cuadrado del centro, a 256 px, en WebP. Así nunca se acerca al
 * límite de 512 KB del bucket (suele quedar en 10–30 KB).
 */
export const LADO_FOTO = 256;
export const MAX_BYTES_FOTO = 512 * 1024;

/** El cuadrado central de una imagen de ancho × alto. */
export const recorteCuadrado = (ancho: number, alto: number) => {
  const lado = Math.min(ancho, alto);
  return { x: (ancho - lado) / 2, y: (alto - lado) / 2, lado };
};

export const reducirFoto = async (fichero: Blob): Promise<Blob> => {
  const imagen = await createImageBitmap(fichero);
  const { x, y, lado } = recorteCuadrado(imagen.width, imagen.height);
  const lienzo = document.createElement("canvas");
  lienzo.width = LADO_FOTO;
  lienzo.height = LADO_FOTO;
  const ctx = lienzo.getContext("2d");
  if (!ctx) throw new Error("Sin lienzo");
  ctx.drawImage(imagen, x, y, lado, lado, 0, 0, LADO_FOTO, LADO_FOTO);
  imagen.close?.();
  const blob = await new Promise<Blob | null>((ok) =>
    lienzo.toBlob(ok, "image/webp", 0.85),
  );
  if (!blob || blob.size > MAX_BYTES_FOTO)
    throw new Error("Foto demasiado grande");
  return blob;
};
